"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldStatus = exports.TenantStatus = exports.FieldDataType = exports.ZendeskFeature = exports.MappingStatus = exports.ConversionWarningCode = exports.AssociatedFileStatus = exports.AssociatedFileType = exports.NotificationScope = exports.DocumentVersionChangeType = exports.ConversionStatus = exports.FileType = exports.IntegrationType = exports.DocumentStatus = exports.DocumentAccessLevel = exports.ShareStatus = exports.ObjectRecordStatus = exports.CrmSyncStatus = exports.ShareTargetType = exports.PermissionType = exports.FolderItemStatus = exports.FolderItemType = exports.FolderStatus = exports.TodoStatus = exports.HubSharedFileContentType = exports.HubSectionType = exports.HubSectionStatus = exports.HubStatus = exports.HubSectionItemStatus = exports.NotationType = exports.PageGroupSource = exports.ShareType = exports.CustomFormRecord = exports.Hub = exports.Meeting = exports.TrainingEvent = exports.IntegrationSettings = exports.IntegrationLog = exports.UserNotations = exports.DocumentSetting = exports.EmailTemplate = exports.UserSettings = exports.User = exports.ContentShare = exports.AttachedFile = exports.Tenant = exports.DocumentVersion = exports.Document = exports.CustomDeck = exports.Folder = void 0;
exports.ReportItem = exports.Dashboard = exports.AvailableDashboards = exports.FeatureFlags = exports.Link = exports.ToDo = exports.HubSharedAssociatedFile = exports.DocumentVersionSettings = exports.SharedFileHubSetting = exports.TextareaHubSettings = exports.HubSection = exports.HubAndContentDetails = exports.Coordinate = exports.Notation = exports.PageGroup = exports.PresentableContentMetadata = exports.ContentTokenOutput = exports.CustomFormRecordRelationshipModel = exports.CustomFormRecordStatus = exports.CustomFormRecordEntity = exports.AttendeeType = exports.MeetingAttendeeStatus = exports.MeetingStatus = exports.MeetingType = exports.Sentiment = exports.MeetingContentType = exports.ContentPresentedStatus = exports.IntegrationRunStatus = exports.LogLevel = exports.PurposeType = exports.UserNotationsType = exports.UserNotationsStatus = exports.EmailTemplateStatus = exports.InputEngineType = exports.ForcePropertyUpdate = exports.UserRole = exports.UserStatus = exports.ShareNotificationScope = exports.AttachedFileEntityType = exports.Frequency = exports.StandaloneFormUsage = exports.CrmIntegrationType = exports.TenantFormStatus = exports.TenantFormTargetType = exports.DateRestriction = exports.PermissionEffect = exports.CustomFieldUsage = exports.FieldPosition = exports.ControlType = exports.FormatValidation = void 0;
exports.TenantFormTargetParameters = exports.ObjectRestriction = exports.ObjectSetting = exports.DocumentPermission = exports.DocumentFieldValueSettings = exports.CustomFieldValueDefinition = exports.DocumentFieldSettings = exports.CommonFieldSettings = exports.CustomFieldDefinition = exports.TenantForm = exports.TenantConfig = exports.ListConfigurationSort = exports.ListConfigurationField = exports.ListConfiguration = exports.FieldConfig = exports.RecordAccessedCount = exports.MostAccessedRecords = exports.MostAccessedRecordsWrapper = exports.MostAccessedRecordsOutput = exports.Highlights = exports.TextWithHighlights = exports.FullTextSearchResultItem = exports.FullTextSearchOutput = exports.RefreshTokenCRMPayload = exports.UserInfoPayload = exports.AuthInformationPayload = exports.ZendeskTokenPayload = exports.PublisherIntegration = exports.AccessTokenData = exports.DocumentVersionIntegration = exports.AssociatedFile = exports.SemVer = exports.LabelValue = exports.PageSetting = exports.S3Object = exports.DocumentIntegration = exports.EditMutex = exports.CustomDeckPage = exports.CustomDeckGroup = exports.GetDependenciesOutput = exports.FolderPermission = exports.LabelValues = exports.ObjectRecordValue = exports.ObjectRecord = exports.CustomValues = exports.SharePermission = exports.FolderItem = exports.GetSharedFoldersOutput = exports.Sheet = exports.ReportGroup = void 0;
exports.CustomFormRecordCRMFields = exports.CRMMeetingRecordInfo = exports.Attendee = exports.FieldValue = exports.PresentedMeta = exports.PagePresentedEvent = exports.ContentPresented = exports.TrainingEventUser = exports.IntegrationLogEntry = exports.IntegrationFieldMapping = exports.IntegrationValueMapping = exports.IntegrationClientConfigurationTuple = exports.Page = exports.AnalyticsFeed = exports.EntityViewed = exports.EntityViewedEvent = exports.UpdateDocVerPageMatchesResult = exports.UpsertVersionContentsResult = exports.SubmitIntegrationResult = exports.BookmarkedDoc = exports.CustomDeckDependencies = exports.CustomDeckAcknowledgement = exports.KeyValue = exports.HubConfig = exports.QuickFilter = exports.CRMStandaloneFormParent = exports.CRMStandaloneForm = exports.CRMAccountToObjectFields = exports.CRMAccountToObjectSetting = exports.CRMTableDetailContentPresented = exports.CRMAdditionalSettings = exports.VeevaSetting = exports.CRMChildTableSetting = exports.CRMTableSetting = exports.CRMAddressSettings = exports.CRMDisplaySettings = exports.CRMAccountSettings = exports.CRMIntegration = exports.FieldListConfig = exports.ListSort = exports.ListConfig = exports.MeetingFieldValueDefinition = exports.MeetingFieldDefinition = void 0;
// @ts-check
const datastore_1 = require("@aws-amplify/datastore");
const schema_1 = require("./schema");
const ShareType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "RECORDING": "RECORDING",
    "ATTACHED_FILE": "ATTACHED_FILE",
    "HUB": "HUB",
    "CUSTOM_DECK": "CUSTOM_DECK"
};
exports.ShareType = ShareType;
const PageGroupSource = {
    "USER": "USER",
    "DOCUMENT": "DOCUMENT"
};
exports.PageGroupSource = PageGroupSource;
const NotationType = {
    "CALLOUT": "CALLOUT",
    "PAGE_NOTE": "PAGE_NOTE",
    "TEXT_INSERTION": "TEXT_INSERTION"
};
exports.NotationType = NotationType;
const HubSectionItemStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.HubSectionItemStatus = HubSectionItemStatus;
const HubStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.HubStatus = HubStatus;
const HubSectionStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.HubSectionStatus = HubSectionStatus;
const HubSectionType = {
    "TEXTAREA": "TEXTAREA",
    "SHARED_FILES": "SHARED_FILES",
    "TODO_LIST": "TODO_LIST",
    "LINKS": "LINKS"
};
exports.HubSectionType = HubSectionType;
const HubSharedFileContentType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION"
};
exports.HubSharedFileContentType = HubSharedFileContentType;
const TodoStatus = {
    "ACTIVE": "ACTIVE",
    "COMPLETED": "COMPLETED",
    "DELETED": "DELETED"
};
exports.TodoStatus = TodoStatus;
const FolderStatus = {
    "ACTIVE": "ACTIVE",
    "ARCHIVED": "ARCHIVED",
    "REMOVED": "REMOVED"
};
exports.FolderStatus = FolderStatus;
const FolderItemType = {
    "FOLDER": "FOLDER",
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "CUSTOM_DECK": "CUSTOM_DECK"
};
exports.FolderItemType = FolderItemType;
const FolderItemStatus = {
    "ACTIVE": "ACTIVE",
    "REMOVED": "REMOVED"
};
exports.FolderItemStatus = FolderItemStatus;
const PermissionType = {
    "VIEW": "VIEW",
    "EDIT": "EDIT"
};
exports.PermissionType = PermissionType;
const ShareTargetType = {
    "USER": "USER",
    "FILTER": "FILTER",
    "ALL": "ALL"
};
exports.ShareTargetType = ShareTargetType;
const CrmSyncStatus = {
    "SYNCED": "SYNCED",
    "NOT_SYNCED": "NOT_SYNCED",
    "DELETED": "DELETED"
};
exports.CrmSyncStatus = CrmSyncStatus;
const ObjectRecordStatus = {
    "ACTIVE": "ACTIVE",
    "REMOVED": "REMOVED"
};
exports.ObjectRecordStatus = ObjectRecordStatus;
const ShareStatus = {
    "IS_SHARED": "IS_SHARED",
    "NOT_SHARED": "NOT_SHARED"
};
exports.ShareStatus = ShareStatus;
const DocumentAccessLevel = {
    "TENANT": "TENANT",
    "USER": "USER"
};
exports.DocumentAccessLevel = DocumentAccessLevel;
const DocumentStatus = {
    "ARCHIVED": "ARCHIVED",
    "REVOKED": "REVOKED",
    "NOT_PUBLISHED": "NOT_PUBLISHED",
    "PUBLISHED": "PUBLISHED",
    "DELETED": "DELETED",
    "ARCHIVED_WITH_VERSIONS": "ARCHIVED_WITH_VERSIONS",
    "REVOKED_WITH_VERSIONS": "REVOKED_WITH_VERSIONS",
    "DELETED_WITH_VERSIONS": "DELETED_WITH_VERSIONS"
};
exports.DocumentStatus = DocumentStatus;
const IntegrationType = {
    "VEEVA": "VEEVA",
    "BEACON": "BEACON",
    "EXPORT_TO_S3": "EXPORT_TO_S3",
    "NONE": "NONE"
};
exports.IntegrationType = IntegrationType;
const FileType = {
    "JPG": "JPG",
    "JPEG": "JPEG",
    "XLS": "XLS",
    "XLSX": "XLSX",
    "XLSM": "XLSM",
    "DOC": "DOC",
    "DOCX": "DOCX",
    "PDF": "PDF",
    "PPTX": "PPTX",
    "PNG": "PNG",
    "MP4": "MP4",
    "WEB": "WEB",
    "HTML": "HTML",
    "ZIP": "ZIP"
};
exports.FileType = FileType;
const ConversionStatus = {
    "PENDING": "PENDING",
    "PROCESSING": "PROCESSING",
    "PROCESSED": "PROCESSED",
    "ERROR": "ERROR"
};
exports.ConversionStatus = ConversionStatus;
const DocumentVersionChangeType = {
    "MAJOR": "MAJOR",
    "MINOR": "MINOR"
};
exports.DocumentVersionChangeType = DocumentVersionChangeType;
const NotificationScope = {
    "NONE": "NONE",
    "EMAIL": "EMAIL",
    "EMAIL_IMMEDIATE": "EMAIL_IMMEDIATE"
};
exports.NotificationScope = NotificationScope;
const AssociatedFileType = {
    "DOCUMENT": "DOCUMENT",
    "ATTACHED_FILE": "ATTACHED_FILE"
};
exports.AssociatedFileType = AssociatedFileType;
const AssociatedFileStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.AssociatedFileStatus = AssociatedFileStatus;
const ConversionWarningCode = {
    "PASSWORD_PROTECTED": "PASSWORD_PROTECTED"
};
exports.ConversionWarningCode = ConversionWarningCode;
const MappingStatus = {
    "HAS_MAPPINGS": "HAS_MAPPINGS",
    "NO_MAPPINGS": "NO_MAPPINGS"
};
exports.MappingStatus = MappingStatus;
const ZendeskFeature = {
    "CHAT": "CHAT",
    "SSO": "SSO"
};
exports.ZendeskFeature = ZendeskFeature;
const FieldDataType = {
    "CATEGORICAL": "CATEGORICAL",
    "MULTICATEGORICAL": "MULTICATEGORICAL",
    "STRING": "STRING",
    "DATE": "DATE",
    "USER_LIST": "USER_LIST",
    "OBJECT": "OBJECT",
    "NUMBER": "NUMBER"
};
exports.FieldDataType = FieldDataType;
const TenantStatus = {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE"
};
exports.TenantStatus = TenantStatus;
const FieldStatus = {
    "DISABLED": "DISABLED",
    "ENABLED": "ENABLED"
};
exports.FieldStatus = FieldStatus;
const FormatValidation = {
    "EMAIL": "EMAIL"
};
exports.FormatValidation = FormatValidation;
const ControlType = {
    "SELECT": "SELECT",
    "RADIOLIST": "RADIOLIST",
    "CHECKBOX": "CHECKBOX",
    "CHECKBOXLIST": "CHECKBOXLIST",
    "CRMACCOUNTSEARCHER": "CRMACCOUNTSEARCHER",
    "CRMATTENDEELIST": "CRMATTENDEELIST",
    "INPUT": "INPUT",
    "TEXTAREA": "TEXTAREA",
    "DATEPICKER": "DATEPICKER",
    "USERLIST": "USERLIST",
    "CUSTOM": "CUSTOM",
    "OBJECT": "OBJECT",
    "LABEL": "LABEL",
    "DATETIMEPICKER": "DATETIMEPICKER"
};
exports.ControlType = ControlType;
const FieldPosition = {
    "LEFT": "LEFT",
    "RIGHT": "RIGHT"
};
exports.FieldPosition = FieldPosition;
const CustomFieldUsage = {
    "USER_FILTER": "USER_FILTER",
    "MEETING": "MEETING",
    "DOCUMENT": "DOCUMENT",
    "EMAIL_TEMPLATE_FILTER": "EMAIL_TEMPLATE_FILTER",
    "CONTENT_SHARE": "CONTENT_SHARE",
    "HUB": "HUB",
    "TENANT_FORM": "TENANT_FORM"
};
exports.CustomFieldUsage = CustomFieldUsage;
const PermissionEffect = {
    "ALLOW": "ALLOW",
    "BLOCK": "BLOCK"
};
exports.PermissionEffect = PermissionEffect;
const DateRestriction = {
    "ONLY_FUTURE": "ONLY_FUTURE",
    "ONLY_PAST": "ONLY_PAST"
};
exports.DateRestriction = DateRestriction;
const TenantFormTargetType = {
    "API": "API"
};
exports.TenantFormTargetType = TenantFormTargetType;
const TenantFormStatus = {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE"
};
exports.TenantFormStatus = TenantFormStatus;
const CrmIntegrationType = {
    "SALESFORCE": "SALESFORCE",
    "VEEVA": "VEEVA"
};
exports.CrmIntegrationType = CrmIntegrationType;
const StandaloneFormUsage = {
    "STANDALONE": "STANDALONE",
    "MEETINGS": "MEETINGS"
};
exports.StandaloneFormUsage = StandaloneFormUsage;
const Frequency = {
    "DAILY": "DAILY",
    "WEEKLY": "WEEKLY",
    "MONTHLY": "MONTHLY"
};
exports.Frequency = Frequency;
const AttachedFileEntityType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "EMAIL_TEMPLATE": "EMAIL_TEMPLATE"
};
exports.AttachedFileEntityType = AttachedFileEntityType;
const ShareNotificationScope = {
    "EMAIL": "EMAIL",
    "NONE": "NONE"
};
exports.ShareNotificationScope = ShareNotificationScope;
const UserStatus = {
    "ACTIVE": "ACTIVE",
    "DEACTIVATED": "DEACTIVATED"
};
exports.UserStatus = UserStatus;
const UserRole = {
    "ALUCIO_ADMIN": "AlucioAdmin",
    "TENANT_ADMIN": "TenantAdmin",
    "TENANT_PUBLISHER": "TenantPublisher",
    "TENANT_VIEWER": "TenantViewer",
    "TEAM_REPORT_VIEWER": "TeamReportViewer"
};
exports.UserRole = UserRole;
const ForcePropertyUpdate = {
    "OVERRIDE": "OVERRIDE",
    "POPULATE": "POPULATE"
};
exports.ForcePropertyUpdate = ForcePropertyUpdate;
const InputEngineType = {
    "MULTICATEGORICAL": "MULTICATEGORICAL",
    "SINGLECATEGORICAL": "SINGLECATEGORICAL"
};
exports.InputEngineType = InputEngineType;
const EmailTemplateStatus = {
    "DRAFT": "DRAFT",
    "ACTIVE": "ACTIVE",
    "DEACTIVATED": "DEACTIVATED",
    "REMOVED": "REMOVED"
};
exports.EmailTemplateStatus = EmailTemplateStatus;
const UserNotationsStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.UserNotationsStatus = UserNotationsStatus;
const UserNotationsType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "CUSTOM_DECK": "CUSTOM_DECK"
};
exports.UserNotationsType = UserNotationsType;
const PurposeType = {
    "INTERNAL_USE_ONLY": "Internal Use Only",
    "EXTERNAL_PROACTIVE": "External - Proactive",
    "EXTERNAL_REACTIVE": "External - Reactive",
    "NOT_DEFINED": "Not Defined"
};
exports.PurposeType = PurposeType;
const LogLevel = {
    "WARNING": "WARNING",
    "ERROR": "ERROR",
    "SUCCESS": "SUCCESS",
    "INFO": "INFO"
};
exports.LogLevel = LogLevel;
const IntegrationRunStatus = {
    "RUNNING": "RUNNING",
    "COMPLETED": "COMPLETED",
    "WARNING": "WARNING",
    "ERROR": "ERROR"
};
exports.IntegrationRunStatus = IntegrationRunStatus;
const ContentPresentedStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.ContentPresentedStatus = ContentPresentedStatus;
const MeetingContentType = {
    "CUSTOM_DECK": "CUSTOM_DECK",
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "DOCUMENT_VERSION_GROUP": "DOCUMENT_VERSION_GROUP"
};
exports.MeetingContentType = MeetingContentType;
const Sentiment = {
    "POSITIVE": "POSITIVE",
    "NEGATIVE": "NEGATIVE"
};
exports.Sentiment = Sentiment;
const MeetingType = {
    "IN_PERSON": "IN_PERSON",
    "VIRTUAL": "VIRTUAL",
    "MANUAL": "MANUAL"
};
exports.MeetingType = MeetingType;
const MeetingStatus = {
    "IN_PROGRESS": "IN_PROGRESS",
    "ENDED_EXIT": "ENDED_EXIT",
    "ENDED_TIMEOUT": "ENDED_TIMEOUT",
    "DELETED": "DELETED",
    "LOCKED": "LOCKED",
    "PLANNED": "PLANNED"
};
exports.MeetingStatus = MeetingStatus;
const MeetingAttendeeStatus = {
    "ACTIVE": "ACTIVE",
    "REMOVED": "REMOVED"
};
exports.MeetingAttendeeStatus = MeetingAttendeeStatus;
const AttendeeType = {
    "PRIMARY": "PRIMARY",
    "SECONDARY": "SECONDARY"
};
exports.AttendeeType = AttendeeType;
const CustomFormRecordEntity = {
    "BEACON_TENANT_FORM": "BEACON_TENANT_FORM",
    "CRM_OBJECT": "CRM_OBJECT",
    "SURVEY_TARGET": "SURVEY_TARGET"
};
exports.CustomFormRecordEntity = CustomFormRecordEntity;
const CustomFormRecordStatus = {
    "ACTIVE": "ACTIVE",
    "LOCKED": "LOCKED",
    "DELETED": "DELETED"
};
exports.CustomFormRecordStatus = CustomFormRecordStatus;
const CustomFormRecordRelationshipModel = {
    "MEETING": "MEETING"
};
exports.CustomFormRecordRelationshipModel = CustomFormRecordRelationshipModel;
const { Folder, CustomDeck, Document, DocumentVersion, Tenant, AttachedFile, ContentShare, User, UserSettings, EmailTemplate, DocumentSetting, UserNotations, IntegrationLog, IntegrationSettings, TrainingEvent, MostAccessedRecordsOutput, MostAccessedRecordsWrapper, MostAccessedRecords, RecordAccessedCount, Meeting, Hub, CustomFormRecord, ContentTokenOutput, PresentableContentMetadata, PageGroup, Notation, Coordinate, HubAndContentDetails, HubSection, TextareaHubSettings, SharedFileHubSetting, DocumentVersionSettings, HubSharedAssociatedFile, ToDo, Link, FeatureFlags, AvailableDashboards, Dashboard, ReportItem, ReportGroup, Sheet, GetSharedFoldersOutput, FolderItem, SharePermission, CustomValues, ObjectRecord, ObjectRecordValue, LabelValues, FolderPermission, GetDependenciesOutput, CustomDeckGroup, CustomDeckPage, EditMutex, DocumentIntegration, S3Object, PageSetting, LabelValue, SemVer, AssociatedFile, DocumentVersionIntegration, AccessTokenData, PublisherIntegration, ZendeskTokenPayload, AuthInformationPayload, UserInfoPayload, RefreshTokenCRMPayload, FullTextSearchOutput, FullTextSearchResultItem, TextWithHighlights, Highlights, FieldConfig, ListConfiguration, ListConfigurationField, ListConfigurationSort, TenantConfig, TenantForm, CustomFieldDefinition, CommonFieldSettings, DocumentFieldSettings, CustomFieldValueDefinition, DocumentFieldValueSettings, DocumentPermission, ObjectSetting, ObjectRestriction, TenantFormTargetParameters, MeetingFieldDefinition, MeetingFieldValueDefinition, ListConfig, ListSort, FieldListConfig, CRMIntegration, CRMAccountSettings, CRMDisplaySettings, CRMAddressSettings, CRMTableSetting, CRMChildTableSetting, VeevaSetting, CRMAdditionalSettings, CRMTableDetailContentPresented, CRMAccountToObjectSetting, CRMAccountToObjectFields, CRMStandaloneForm, CRMStandaloneFormParent, QuickFilter, HubConfig, KeyValue, CustomDeckAcknowledgement, CustomDeckDependencies, BookmarkedDoc, SubmitIntegrationResult, UpsertVersionContentsResult, UpdateDocVerPageMatchesResult, EntityViewedEvent, EntityViewed, AnalyticsFeed, Page, IntegrationClientConfigurationTuple, IntegrationValueMapping, IntegrationFieldMapping, IntegrationLogEntry, TrainingEventUser, ContentPresented, PagePresentedEvent, PresentedMeta, FieldValue, Attendee, CRMMeetingRecordInfo, CustomFormRecordCRMFields } = (0, datastore_1.initSchema)(schema_1.schema);
exports.Folder = Folder;
exports.CustomDeck = CustomDeck;
exports.Document = Document;
exports.DocumentVersion = DocumentVersion;
exports.Tenant = Tenant;
exports.AttachedFile = AttachedFile;
exports.ContentShare = ContentShare;
exports.User = User;
exports.UserSettings = UserSettings;
exports.EmailTemplate = EmailTemplate;
exports.DocumentSetting = DocumentSetting;
exports.UserNotations = UserNotations;
exports.IntegrationLog = IntegrationLog;
exports.IntegrationSettings = IntegrationSettings;
exports.TrainingEvent = TrainingEvent;
exports.MostAccessedRecordsOutput = MostAccessedRecordsOutput;
exports.MostAccessedRecordsWrapper = MostAccessedRecordsWrapper;
exports.MostAccessedRecords = MostAccessedRecords;
exports.RecordAccessedCount = RecordAccessedCount;
exports.Meeting = Meeting;
exports.Hub = Hub;
exports.CustomFormRecord = CustomFormRecord;
exports.ContentTokenOutput = ContentTokenOutput;
exports.PresentableContentMetadata = PresentableContentMetadata;
exports.PageGroup = PageGroup;
exports.Notation = Notation;
exports.Coordinate = Coordinate;
exports.HubAndContentDetails = HubAndContentDetails;
exports.HubSection = HubSection;
exports.TextareaHubSettings = TextareaHubSettings;
exports.SharedFileHubSetting = SharedFileHubSetting;
exports.DocumentVersionSettings = DocumentVersionSettings;
exports.HubSharedAssociatedFile = HubSharedAssociatedFile;
exports.ToDo = ToDo;
exports.Link = Link;
exports.FeatureFlags = FeatureFlags;
exports.AvailableDashboards = AvailableDashboards;
exports.Dashboard = Dashboard;
exports.ReportItem = ReportItem;
exports.ReportGroup = ReportGroup;
exports.Sheet = Sheet;
exports.GetSharedFoldersOutput = GetSharedFoldersOutput;
exports.FolderItem = FolderItem;
exports.SharePermission = SharePermission;
exports.CustomValues = CustomValues;
exports.ObjectRecord = ObjectRecord;
exports.ObjectRecordValue = ObjectRecordValue;
exports.LabelValues = LabelValues;
exports.FolderPermission = FolderPermission;
exports.GetDependenciesOutput = GetDependenciesOutput;
exports.CustomDeckGroup = CustomDeckGroup;
exports.CustomDeckPage = CustomDeckPage;
exports.EditMutex = EditMutex;
exports.DocumentIntegration = DocumentIntegration;
exports.S3Object = S3Object;
exports.PageSetting = PageSetting;
exports.LabelValue = LabelValue;
exports.SemVer = SemVer;
exports.AssociatedFile = AssociatedFile;
exports.DocumentVersionIntegration = DocumentVersionIntegration;
exports.AccessTokenData = AccessTokenData;
exports.PublisherIntegration = PublisherIntegration;
exports.ZendeskTokenPayload = ZendeskTokenPayload;
exports.AuthInformationPayload = AuthInformationPayload;
exports.UserInfoPayload = UserInfoPayload;
exports.RefreshTokenCRMPayload = RefreshTokenCRMPayload;
exports.FullTextSearchOutput = FullTextSearchOutput;
exports.FullTextSearchResultItem = FullTextSearchResultItem;
exports.TextWithHighlights = TextWithHighlights;
exports.Highlights = Highlights;
exports.FieldConfig = FieldConfig;
exports.ListConfiguration = ListConfiguration;
exports.ListConfigurationField = ListConfigurationField;
exports.ListConfigurationSort = ListConfigurationSort;
exports.TenantConfig = TenantConfig;
exports.TenantForm = TenantForm;
exports.CustomFieldDefinition = CustomFieldDefinition;
exports.CommonFieldSettings = CommonFieldSettings;
exports.DocumentFieldSettings = DocumentFieldSettings;
exports.CustomFieldValueDefinition = CustomFieldValueDefinition;
exports.DocumentFieldValueSettings = DocumentFieldValueSettings;
exports.DocumentPermission = DocumentPermission;
exports.ObjectSetting = ObjectSetting;
exports.ObjectRestriction = ObjectRestriction;
exports.TenantFormTargetParameters = TenantFormTargetParameters;
exports.MeetingFieldDefinition = MeetingFieldDefinition;
exports.MeetingFieldValueDefinition = MeetingFieldValueDefinition;
exports.ListConfig = ListConfig;
exports.ListSort = ListSort;
exports.FieldListConfig = FieldListConfig;
exports.CRMIntegration = CRMIntegration;
exports.CRMAccountSettings = CRMAccountSettings;
exports.CRMDisplaySettings = CRMDisplaySettings;
exports.CRMAddressSettings = CRMAddressSettings;
exports.CRMTableSetting = CRMTableSetting;
exports.CRMChildTableSetting = CRMChildTableSetting;
exports.VeevaSetting = VeevaSetting;
exports.CRMAdditionalSettings = CRMAdditionalSettings;
exports.CRMTableDetailContentPresented = CRMTableDetailContentPresented;
exports.CRMAccountToObjectSetting = CRMAccountToObjectSetting;
exports.CRMAccountToObjectFields = CRMAccountToObjectFields;
exports.CRMStandaloneForm = CRMStandaloneForm;
exports.CRMStandaloneFormParent = CRMStandaloneFormParent;
exports.QuickFilter = QuickFilter;
exports.HubConfig = HubConfig;
exports.KeyValue = KeyValue;
exports.CustomDeckAcknowledgement = CustomDeckAcknowledgement;
exports.CustomDeckDependencies = CustomDeckDependencies;
exports.BookmarkedDoc = BookmarkedDoc;
exports.SubmitIntegrationResult = SubmitIntegrationResult;
exports.UpsertVersionContentsResult = UpsertVersionContentsResult;
exports.UpdateDocVerPageMatchesResult = UpdateDocVerPageMatchesResult;
exports.EntityViewedEvent = EntityViewedEvent;
exports.EntityViewed = EntityViewed;
exports.AnalyticsFeed = AnalyticsFeed;
exports.Page = Page;
exports.IntegrationClientConfigurationTuple = IntegrationClientConfigurationTuple;
exports.IntegrationValueMapping = IntegrationValueMapping;
exports.IntegrationFieldMapping = IntegrationFieldMapping;
exports.IntegrationLogEntry = IntegrationLogEntry;
exports.TrainingEventUser = TrainingEventUser;
exports.ContentPresented = ContentPresented;
exports.PagePresentedEvent = PagePresentedEvent;
exports.PresentedMeta = PresentedMeta;
exports.FieldValue = FieldValue;
exports.Attendee = Attendee;
exports.CRMMeetingRecordInfo = CRMMeetingRecordInfo;
exports.CustomFormRecordCRMFields = CustomFormRecordCRMFields;
//# sourceMappingURL=index.js.map